<body>
    <div class="box">
        <h2>M.R. SignUp</h2>
        <form (ngSubmit)="onSubmit()" [formGroup]="mrform" >
            <div class="inputBox">
                <input type="name" name="email" formControlName="name"  required onkeyup="this.setAttribute('value', this.value);" value="">
                <label>Name</label>
            </div>
            <div class="inputBox">
                <input type="email" name="email" formControlName="email"  required onkeyup="this.setAttribute('value', this.value);" value="">
                <label>Email</label>
            </div>
            <div class="inputBox">
                <input type="phone" name="email" formControlName="phone"  required onkeyup="this.setAttribute('value', this.value);" value="">
                <label>Phone-No.</label>
            </div>
            <div class="inputBox">
                <input type="dessignation" name="email" formControlName="designation"  required onkeyup="this.setAttribute('value', this.value);" value="">
                <label>Designation</label>
            </div>
              <!-- <div class="inputBox">
                <input type="email" name="email" required onkeyup="this.setAttribute('value', this.value);" value="">
                <label>Company</label>
            </div> -->
            <div class="inputBox">
                <input type="password" name="password" formControlName="password"  required value=""
                    onkeyup="this.setAttribute('value', this.value);" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters">
                <label>Password</label>
            </div>
            <input type="submit" name="sign-in" value="Sign In">
        </form>
        <br />
        <p>Already a user?<a href="/Market">LOGIN</a></p>
    </div>
</body>